import type {
  Allocation,
  ProposalOrder,
} from '@moment/horizon-data-access/proposal'

/**
 * Find an allocation and its parent order by proposal_allocation_id
 */
export function findAllocationInOrders(
  orders: ProposalOrder[],
  proposalAllocationId: string,
): { order: ProposalOrder; allocation: Allocation } | null {
  for (const order of orders) {
    const allocation = order.allocations.find(
      (a) => a.proposal_allocation_id === proposalAllocationId,
    )
    if (allocation) return { order, allocation }
  }
  return null
}
